import React, { Component } from "react";
import "./App.css";
import Navi from "./Navigation/Nav";
class App extends Component {
  render() {
    return (
      <div className="App">
        <Navi />
      </div>
    );
  }
}

export default App;
